import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const ForgeActionModule = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "forge-action" */ './forge-action')),
    LoadingSkeleton: () => null,
});
